import { css } from "@emotion/css";
import React from "react";
import { Card, Icon, Menu } from "semantic-ui-react";
import "../../../styles/ui.scss";
import { getIsGreaterThanMobile, isEmptyValue } from "../../../helpers/GlobalHelper";
import { getIsWhiteLabeled } from "../../../helpers/PermissionHelper";
import { useBCGlobalCacheReducer } from "../../BCGlobaleCacheStore";

interface LMSTabMenuBarProps {
  tabs: any[];
  activeTab: string,
  setActiveTab: any,
  customColor?: any;
  menuBreakIndex?: number;
  menuWidths?: number;
}
const TabNameContent = ({ tabNameUpper, tableLength, tabSuffix }) => {
  const [{ apiCacheGridCounts }]: any = useBCGlobalCacheReducer();
  const hasLength = !isEmptyValue(apiCacheGridCounts?.[tabSuffix]) || !isEmptyValue(tableLength);
  const tabLengthDisplay = !isEmptyValue(apiCacheGridCounts?.[tabSuffix]) ? apiCacheGridCounts?.[tabSuffix] : !isEmptyValue(tableLength) ? tableLength : "";
  return <div className="menu-tab-name-container">
    <span></span>
    <span style={{ whiteSpace: "pre-wrap" }}>{tabNameUpper}</span>
    {hasLength && <span className={"menu-tab-name-table-length"}><span>{tabLengthDisplay}</span></span>}
  </div>;
};

const LmsTabMenuBar = ({ ...props }: LMSTabMenuBarProps) => {
  const menuBreakIndex = props.menuBreakIndex || 10;
  const isGreaterThanMobile = getIsGreaterThanMobile();
  const menuWidths = props.menuWidths || props.tabs.slice(0, menuBreakIndex).length as any;
  const brokerActiveTabOverrideCSS = css`
    .active.item {
      color: ${props.customColor ? props.customColor : "black"} !important;
      border-color: ${props.customColor ? props.customColor : "black"} !important;
      font-weight: normal;
    }

    & :hover {
      color: ${props.customColor ? props.customColor : "black"} !important;
    }
  `;

  const getMenuWithItems = (tabs) => {
    return <Menu className={`tab-menu ${(getIsWhiteLabeled()) && brokerActiveTabOverrideCSS}`} pointing secondary fluid widths={menuWidths}>
      {tabs.map((tab, i) => {
        let tabName = tab;
        if (tab.name) {
          tabName = tab.name;
        }

        const tabNameUpper = tabName.toLocaleUpperCase();

        if (!isGreaterThanMobile && tab.icon) {
          return (
            <Menu.Item
              key={"tab_" + i}
              active={props.activeTab === tabNameUpper}
              onClick={() => props.setActiveTab(tabNameUpper)}
            >
              <Icon size="large" name={tab.icon}/>
            </Menu.Item>
          );
        }
        else {
          return (
            <Menu.Item
              key={"tab_" + i}
              content={<TabNameContent tabNameUpper={tabNameUpper} tableLength={tab?.tableLength} tabSuffix={tab?.suffix} />}
              active={props.activeTab === tabNameUpper}
              onClick={() => props.setActiveTab(tabNameUpper)}
            />
          );
        }
      })}
    </Menu>;
  };

  return <React.Fragment>
    {props.tabs.length > 0 && <Card fluid className='tab-menubar-container'>
      {getMenuWithItems(props.tabs.slice(0, menuBreakIndex))}
      {props.tabs.length > menuBreakIndex && getMenuWithItems(props.tabs.slice(menuBreakIndex, menuBreakIndex * 2))}
      {props.tabs.length > menuBreakIndex * 2 && getMenuWithItems(props.tabs.slice(menuBreakIndex * 2))}
    </Card>}
  </React.Fragment>;
};

export default LmsTabMenuBar;